import { customerApi } from "../utils/apiConfig";

const authConfig = (params) => ({
  params,
  headers: {
    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  },
});

export const getOvertimeContext = () =>
  customerApi.get("/overtime/context", authConfig());

export const getOvertimePersonnel = (params = {}) =>
  customerApi.get("/overtime/personnel", authConfig(params));

export const getOvertimeEntries = (params) =>
  customerApi.get("/overtime/entries", authConfig(params));

export const getOvertimeSummary = (params) =>
  customerApi.get("/overtime/summary", authConfig(params));

export const getOvertimeAnalysis = (params) =>
  customerApi.get("/overtime/analysis", authConfig(params));

export const createOvertimeEntry = (payload) =>
  customerApi.post("/overtime/entries", payload, authConfig());

export const updateOvertimeEntry = (payload) =>
  customerApi.post("/overtime/entries/update", payload, authConfig());

export const deleteOvertimeEntry = (id) =>
  customerApi.post("/overtime/entries/delete", { id }, authConfig());

export const createOvertimeOption = (payload) =>
  customerApi.post("/overtime/options", payload, authConfig());

export const deleteOvertimeOption = (id) =>
  customerApi.post("/overtime/options/delete", { id }, authConfig());
